import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Heading = styled.section`
  width: 620px;
  text-align: center;
  margin-top: -100px;
  margin-bottom: 80px;
  margin-left: 350px;
  position: absolute;
`;
export const H2 = styled.h2`
  position: relative;
  padding: 10px;
  font-size: 28px;
  font-weight: 800;
  color: #232d39;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 0px;
  margin-bottom: 0px;
`;
export const Parghraph = styled.p`
  margin-left: 60px;
  font-size: 14px;
  line-height: 25px;
  color: #7a7a7a;
  width: 520px;
`;
export const Image = styled.img`
  position: relative;
  margin: 20px auto;
  vertical-align: middle;
  text-align: center;
`;
export const Span = styled.span`
  font-style: normal;
  color: #ed563b;
`;
export const TopSection = styled.section`
  display: flex;
  flex-wrap: wrap;
  margin-right: 50px;
  margin-left: 50px;
  width: 1225px;
`;
export const Items = styled.ul`
  font-style: normal;
  color: #ed563b;
`;
export const List = styled.li`
  width: 100%;
  list-style: none;
`;
export const Link = styled.a`
  width: 300px;
  position: relative;
  left: 60px;
  display: flex;
  background-color: #fff;
  font-size: 19px;
  margin-bottom: 3px;
  letter-spacing: 0.5px;
  font-weight: 600;
  text-decoration: none;
`;
export const ImageLink = styled.img`
  position: absolute;
  max-width: 100%;
  margin-right: 250px;
  margin-left: 2px;
`;
export const BtnTab = styled.a`
  text-align: center;
  padding: 20px 30px;
  width: 350px;
  height: 68px;
  border-radius: 5px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  color: #fff;
  font-size: 19px;
  letter-spacing: 0.5px;
  font-weight: 600;
  background-color: #ed563b;
  text-decoration: none;
  margin-top: 640px;
  margin-left: 30px;
  cursor: pointer;
`;
export const Section = styled.section`
  margin-left: 450px;
  margin-bottom: 450px;
  position: absolute;
`;
export const Artical = styled.article`
  margin-top: 126px;
  margin-left: 30px;
  width: 700px;
  height: 548.35px;
`;
export const ImgTab = styled.img`
  max-width: 100%;
  overflow: hidden;
  border-radius: 5px;
`;
export const H4 = styled.h4`
  font-size: 23px;
  font-weight: 700;
  color: #232d39;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
  margin-top: 30px;
`;
export const Info = styled.p`
  font-size: 14px;
  color: #7a7a7a;
  margin-bottom: 28px;
  width: 690px;
`;
export const LinkTap = styled.a`
  display: inline-block;
  font-size: 15px;
  padding: 12px 20px;
  background-color: #ed563b;
  color: #fff;
  text-align: center;
  font-weight: 400;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
`;
